module.exports = __webpack_public_path__ + "media/theme/icon__fast-deliver-af04f8db.svg";